module.exports = "pegasus/assets/themelp1/travel/103.png";